<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">This book is dedicated to my mother, Margarete Ola Cook, for teaching me to be open to everything, ask a lot of questions and believe in the truth in my heart!</p>
<p class="indent">Also, to my three wise men: my father, John Macy and Egan. You three know the truth and have given me a glimpse when I needed it the most.</p>
<p class="indent">Also, thanks of course to Russell Dandridge, who is constantly my best friend and supporter as well as so many other things all in one package that I could never have found anywhere else.</p>
<p class="indent">Thanks also to the folks who spoke to me about the various haunted places listed in this book and particularly Jeremy Cannon, whom Russell talked to at Veal Station Cemetery one Sunday afternoon when he was there taking photos.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?776e21ba